import { useQuery } from "@tanstack/react-query";

import { getTheme } from "../../api/Theme";
import { ITheme, IThemePage } from "shared";

export const useTheme = (id: number) => {
  return useQuery<ITheme<IThemePage>>({ queryKey: ["theme", id], queryFn: () => getTheme(id) });
};
